import vars from "_c/AppShell/ui-vars";
import { IS_SERVER } from "@/misc/constants";

export const scrollTo = (selector, behavior = "smooth") => {
  if (IS_SERVER) {
    return;
  }
  let $el = selector;
  if (typeof selector === "string") {
    $el = document.querySelector(selector);
  }
  if (!$el) return;
  const top = ($el?.getBoundingClientRect()?.top || 0) + window.scrollY;
  const windowWidth = window.innerWidth;
  let offset;
  if (windowWidth > vars.mobileBp) {
    offset = parseInt(vars.headDesktopHeight);
  } else {
    offset = parseInt(vars.headMobileHeight);
  }
  window.scrollTo({
    top: Math.max(0, top - offset),
    behavior,
  });
};
